import Vue from 'vue'
import selectVariant from './component/index.vue'
import toast from '@/plugins/toast'
import slide from '@/components/slide'
import bridge from '@beastshop/bridge'
import browser from '@beastshop/browser'


Vue.use(toast)
const isApp = browser.app()
const uniapp = browser.uniapp()
let vm, _resolve, _reject
let plugin =  {
  install (vue, options) {
    
    vue.prototype.$selectVariant = (data, noApp) => {
      if (isApp && !noApp && !uniapp) {
        return bridge.selectProductVariant(data)
      }

      if (data.variant.dimensionGroup && data.variant.dimensionGroup.length) {
        const _g = {}

        data.variant.dimensionGroup.forEach(g => {
          const v = g.value[0]
          _g[v] = g.name
        })

        data._dimensionGroup = _g
      }

      vm = new Vue({
        el: document.createElement('div'),
        template: `<slide from="bottom" :slidecls="data.slideCls" :show="show" @maskTap="maskTap" :style="{top: showPreview ? 0 : 'auto'}">
          <select-variant :data="data" :show="show" @complete="complete" @preview-image="previewImage"/>
          </slide>`,
        data: {
          data: data,
          show: false,
          showPreview: false
        },
        components: {
          'select-variant': selectVariant,
          slide
        },
        methods: {
          complete (result) {
            this.close()
            result === null
              ? _reject(cancelError())
              : _resolve(result)
          },
          // error (message) {
          //   this.close()
          //   _reject(message)
          // },
          close () {
            this.show = false
            document.body.removeChild(vm.$el)
          },
          maskTap () {
            this.close()
            _reject(cancelError())
          },

          previewImage () {
            console.log(1)
            this.showPreview = true
          }
        }
      }) 
      document.body.appendChild(vm.$el)
      setTimeout(() => {
        vm.show = true      
      }, 0)

      return new Promise((resolve, reject) => {
        _resolve = resolve
        _reject = reject
      })

    }
  }
}

Vue.use(plugin)



function cancelError(){
  let error = new Error('USER_CANCEL')
  error.code = 'USER_CANCEL'
  return error
}

// this.$selectVariant({
//   data:123
// })
//   .then((result) => {
    
//   })
//   .catch(() => {
    
//   })



// WEBPACK FOOTER //
// ./static/plugins/select-variant/index.js